// extracted by mini-css-extract-plugin
export var card = "_4w-0";
export var content = "_4w-1";
export var contentLoading = "_4w-2";